// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_qe6","newExpiryDate":"styles_newExpiryDate__1hNuH","footer":"styles_footer__2zXmc"};